import { Button, Input } from 'antd'

const ImageUploadSection = ({
	t,
	imageList,
	handleFileChange,
	uploadImg,
	viewImage,
	deleteRow,
	addNewRow,
}) => (
	<div>
		{imageList.map((image, index) => (
			<div
				key={index}
				className="flex w-full items-start gap-1 flex-col mt-5 mb-10"
			>
				<div>
					<p className="font-bold">
						{t('photo')}-{index + 1}
					</p>
				</div>
				<div className="flex items-center gap-3">
					<Input
						type="file"
						onChange={(e) => handleFileChange(e, index)}
						className="w-full"
					/>

					<Button
						onClick={() => uploadImg(index)}
						isLoading={image.imgLoading}
						className="h-9 w-[200px] rounded-3xl bg-[#0A4D68] text-white"
					>
						{t('upload')}
					</Button>
					{image.path && (
						<Button
							onClick={() => viewImage(index)}
							className="h-9 w-[200px] rounded-3xl bg-[#0A4D68] text-white"
						>
							{t('download')}
						</Button>
					)}
					{index !== 0 && (
						<Button
							onClick={() => deleteRow(index)}
							className="h-9 w-[70px] rounded-3xl  bg-red-500 text-white"
						>
							{/* {t("delete")} */}-
						</Button>
					)}

					{index === imageList.length - 1 && (
						<Button
							onClick={addNewRow}
							className="h-9 w-[70px] rounded-3xl bg-[#0A4D68] text-white"
						>
							{/* {t("add2")} */}+
						</Button>
					)}
				</div>
			</div>
		))}
	</div>
)

export default ImageUploadSection
